import React, { useEffect, useState } from 'react';
import styles from './PriceProductComponent.module.scss';
import { getCurrentVariant, sanitizeType } from 'functions';
import Tooltip from '../../../Tooltip/Tooltip';

const PriceProductComponent = ({ properties, type, animationData }) => {
  return (
    !!properties?.productsSumPrice?.value && (
      <div
        className={` ${styles.containerPrice} ${sanitizeType(type, styles)}`}
        data-aos={animationData?.animation}
        data-aos-offset={animationData?.animationOffset}
        data-aos-delay={animationData?.animationDelay}
        data-aos-duration={animationData?.animationDuration}
        data-aos-easing={animationData?.animationEasing}
      >
        <div className={styles.wrapperPrice}>
          <p className={styles.price}>{properties.productsSumPrice.value}</p>
          <p className={styles.priceSign}>,-</p>
          {!!properties?.productsSumPrice?.suffix && <p className={styles.text}>{properties.productsSumPrice.suffix}</p>}
          {(!!properties?.productsSumPrice?.tooltipContent?.title || !!properties?.productsSumPrice?.tooltipContent?.description) && (
            <Tooltip type={`infoProduct ${type}`}>
              {!!properties?.productsSumPrice?.tooltipContent?.title && <p>{properties?.productsSumPrice?.tooltipContent?.title}</p>}
              {!!properties?.productsSumPrice?.tooltipContent?.description && <p>{properties?.productsSumPrice?.tooltipContent?.description}</p>}
            </Tooltip>
          )}
        </div>
      </div>
    )
  );
};

export default PriceProductComponent;
